// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mj-c";
export var backButton = "_mj-4";
export var backIcon = "_mj-5";
export var chevronShortcut = "_mj-6";
export var container = "_mj-1";
export var editor = "_mj-8";
export var editorWrapper = "_mj-7";
export var prefix = "_mj-2";
export var searchIcon = "_mj-3";
export var suffix = "_mj-9";
export var suffixContent = "_mj-a";
export var suffixText = "_mj-b";
export var wrapper = "_mj-0";